import { Inline } from "PFComponents/containers/flex/inline";
import { Stack } from "PFComponents/containers/flex/stack";
import { Divider } from "PFComponents/divider";
import { ReadOnlyField } from "PFComponents/read_only_field";
import { Typography } from "PFComponents/typography";
import { isTaggable } from "PFCore/helpers/is_taggable";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import { PureCustomValueCamelCased } from "PFTypes";
import { useTranslation } from "react-i18next";

import { useCustomValuePreviewContext } from "../../context/custom_value_preview_context";
import css from "../../custom_value_preview.module.scss";
import { TagsSection } from "./tags_section";

type DetailsProps = {
  customValue: PureCustomValueCamelCased;
};

export const Details = ({ customValue }: DetailsProps) => {
  const { t } = useTranslation("translation", { keyPrefix: "customValueSidepanel" });
  const { formatDate } = useDateFormatter();
  const { customType } = useCustomValuePreviewContext();

  const tagsEnabled = isTaggable(customType);

  return (
    <>
      {customValue.description && (
        <>
          <Divider />
          <Stack gap="spacingMd">
            <Typography variant="h5">{t("description")}</Typography>
            <Typography variant="bodyRegular">{customValue.description}</Typography>
          </Stack>
        </>
      )}
      <Divider />
      {tagsEnabled && (
        <>
          <TagsSection customValue={customValue} />
          <Divider />
        </>
      )}
      <Stack gap="spacingMd">
        <Typography variant="h5">{t("insights")}</Typography>
        <Inline spread>
          <ReadOnlyField
            classes={{ root: css.halfWidth }}
            label={t("membersWithThis")}
            value={customValue.profilesCount || 0}
          />
          <ReadOnlyField
            classes={{ root: css.halfWidth }}
            label={t("requiredInCurrentActivities")}
            value={customValue.activitiesCount || 0}
          />
        </Inline>
        <Inline spread>
          <ReadOnlyField
            classes={{ root: css.halfWidth }}
            label={t("addedToAccount")}
            value={formatDate(customValue.createdAt)}
          />
          <ReadOnlyField
            classes={{ root: css.halfWidth }}
            label={t("lastEditedInAccount")}
            value={formatDate(customValue.updatedAt)}
          />
        </Inline>
      </Stack>
    </>
  );
};
